import { render } from "./BulkDownload.vue?vue&type=template&id=f16bc298"
import script from "./BulkDownload.vue?vue&type=script&lang=ts"
export * from "./BulkDownload.vue?vue&type=script&lang=ts"
script.render = render

export default script